module.exports = __webpack_public_path__ + "img/ptu-3.11db6841.png";